import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { GlobeAltIcon } from "@heroicons/react/24/outline";
import { useLanguage } from "../contexts/LanguageContext";

export default function LanguageSelector({ textColor }) {
  const { language, setLanguage } = useLanguage();

  const languages = [
    { code: "en", name: "English" },
    { code: "es", name: "Español" },
    { code: "de", name: "Deutsch" },
    { code: "fr", name: "Français" },
    { code: "it", name: "Italiano" },
    { code: "el", name: "Ελληνικά" },
    { code: "pl", name: "Polski" },
    { code: "pt", name: "Português" },
    { code: "tr", name: "Türkçe" },
  ];

  return (
    <Menu as="div" className="relative">
      <Menu.Button className="flex items-center place-items-end ml-2">
        <GlobeAltIcon
          className="h-5 w-5"
          style={textColor ? { color: textColor } : undefined}
        />
        <span
          className="ml-1 text-sm font-medium hidden sm:inline-flex"
          style={textColor ? { color: textColor } : undefined}
        >
          {languages.find((lang) => lang.code === language)?.name}
        </span>
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-10 mt-2 min-w-24 whitespace-nowrap origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-hidden">
          {languages.map((lang) => (
            <Menu.Item key={lang.code}>
              {({ active }) => (
                <button
                  onClick={() => setLanguage(lang.code)}
                  className={`${active ? "bg-gray-100" : ""} ${
                    language === lang.code ? "font-medium" : ""
                  } block px-4 py-2 text-sm text-gray-700 w-full text-left`}
                >
                  {lang.name}
                </button>
              )}
            </Menu.Item>
          ))}
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
